import { useState } from 'react';
import type { AccountUserRole, AccountUserRoleRaw, AccountUserRolesListResponseRaw } from 'vopay';
import { api } from '@/services/api.config';

// Backend returns Roles index-keyed (or as an array) with stringly-typed fields.
// Normalize into the clean AccountUserRole shape.
function normalizeRoles(roles: AccountUserRolesListResponseRaw['Roles']): AccountUserRole[] {
  const list: AccountUserRoleRaw[] = Array.isArray(roles) ? roles : Object.values(roles);
  return list.map((role) => ({
    RoleID: parseInt(role.RoleID, 10),
    Name: role.Name,
    ApplyToAllSubaccounts:
      role.ApplyToAllSubaccounts === '1' || role.ApplyToAllSubaccounts.toLowerCase() === 'true',
    Permissions: role.Permissions
      ? Array.isArray(role.Permissions)
        ? role.Permissions
        : Object.values(role.Permissions)
      : [],
  }));
}

export default function useFetchAccountUserRoles() {
  const [fetching, setFetching] = useState(false);
  const [roles, setRoles] = useState<AccountUserRole[]>([]);

  async function fetchAccountUserRoles(): Promise<AccountUserRolesListResponseRaw> {
    try {
      setFetching(true);
      const res = await api.fetchAccountUserRoles();
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      setRoles(normalizeRoles(res.Roles));
      return res;
    } catch (error) {
      console.error('Fetch account user roles failed:', error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, roles, fetchAccountUserRoles };
}
